$(document).ready(function() {
    var defaultData_1 = false;
    var defaultData_2 = false;
    var observer = new IntersectionObserver(onIntersection, {
        root: null,
        threshold: 0.5 // 0.5 means 50% of the element must be in the viewport
    });

    function onIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                $(entry.target).addClass('visible');
                const $target = $(entry.target); // jQuery object for the observed element
                const classes = $target.attr('class').split(' '); // Get and split the classes
                if(classes[0] == "why-choose-us-section-1"){
                    if(defaultData_1){

                    }else{
                        startNumber_1();
                        defaultData_1 = true;
                    }
                }
                if(classes[0] == "why-choose-us-section-2"){
                    if(defaultData_2){

                    }else{
                        startNumber_2();
                        defaultData_2 = true;
                    }
                }
            } 
        });
    }

    observer.observe($('.video-section')[0]); // Use [0] to access the DOM element
    observer.observe($('.why-choose-us-section-1')[0]);
    observer.observe($('.why-choose-us-section-2')[0]);
});

function startNumber_1(){
    $(".stat-number-1").each(function () {
    var size = $(this).text().split(".")[1]
        ? $(this).text().split(".")[1].length
        : 0;
    $(this)
        .prop("Counter", 0)
        .animate(
            {
                Counter: $(this).text()
            },
            {
                duration: 4000,
                step: function (func) {
                $(this).text(parseFloat(func).toFixed(size));
                }
            }
        ).promise().done(function () {
            // Animation is finished, add the 'active' class to elements with class 'vl'
            $(".vl-1").addClass("active");
        });
    });
}
function startNumber_2(){
    $(".stat-number-2").each(function () {
    var size = $(this).text().split(".")[1]
        ? $(this).text().split(".")[1].length
        : 0;
    $(this)
        .prop("Counter", 0)
        .animate(
            {
                Counter: $(this).text()
            },
            {
                duration: 4000,
                step: function (func) {
                $(this).text(parseFloat(func).toFixed(size));
                }
            }
        ).promise().done(function () {
            // Animation is finished, add the 'active' class to elements with class 'vl'
            $(".vl-2").addClass("active");
        });
    });
}



// START HOMEPAGE
    setTimeout(function() {
        $('.start-zoom').removeClass('start-zoom');
    }, 700);
    setTimeout(function() {
        $('.start-up').removeClass('start-up');
    }, 1300);
    $('#homepage-slider').slick({
        slidesToShow: 1,
        arrows: true,
        dots: true,
        fade:true,
        infinite:false,
        draggable: true,
        prevArrow: $('#banner-prev-btn'),
        nextArrow: $('#banner-next-btn'),
        appendDots: $('.dot-slider')

        
    });
    $('#homepage-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        // Get the number of slides
        var slideCount = slick.slideCount;
        var prevArrow = $('#banner-prev-btn');
        var nextArrow = $('#banner-next-btn');
        $('.banner-item .first-text').removeClass('active');
        $('.banner-item .second-text').removeClass('active');
        $('.banner-item p').removeClass('active');
        $('.banner-item .two-btn-1').removeClass('active');

        setTimeout(function() {
            $('.slick-current .first-text').addClass('active');
            $('.slick-current .second-text').addClass('active');
            $('.slick-current p').addClass('active');
            $('.slick-current .two-btn-1').addClass('active');
            console.log('here');
        }, 500);
        // Change opacity based on the current slide position
        if (nextSlide === 0) {
        prevArrow.css('opacity', '0.5');
        nextArrow.css('opacity', '1');
        } else if (nextSlide === slideCount - 1) {
        prevArrow.css('opacity', '1');
        nextArrow.css('opacity', '0.5');
        } else {
        prevArrow.css('opacity', '1');
        nextArrow.css('opacity', '1');
        }
    });
// END HOMEPAGE
// START POPULAR PRODUCT SLIDER
    var calc;
    var cityName = "outdoor-cameras";
    sliderIni();
    progressIni();

    $(".tablinks").click(function() {
        cityName = $(this).data("city");
        $(".tabcontent").hide();
        $(".tablinks").removeClass("active");
        $("[data-city='" + cityName + "']").show();
        $(this).addClass("active");
        sliderIni();
        
        $('.collection-products-slider').slick('refresh');
        $('.collection-products-slider-mobile').slick('refresh');
        $('.collection-products-slider').slick('slickGoTo', 1);
        progressIni();
        if($('.collection-products-slider-mobile.'+cityName).slick("slickGetOption", "slidesToShow") >= $('.collection-products-slider-mobile.'+cityName +' .product-item').length){
            $('.'+cityName+'.progress').css('background-size', 100 + '% 100%').attr('aria-valuenow', 100 );
        }
        if($('.collection-products-slider.'+cityName).slick("slickGetOption", "slidesToShow") >= $('.collection-products-slider.'+cityName +' .product-item').length){
            $('.'+cityName+'.progress').css('background-size', 100 + '% 100%').attr('aria-valuenow', 100 );
        }
    });

    function sliderIni(){
        try{    
            $('.collection-products-slider-mobile').slick({
                slidesToShow: 4,
                rows: 0,
                infinite:false,
                arrows:true,
                draggable: true,
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3,
                            rows: 0
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            rows: 0
                        }
                    },
                    {
                        //tablet
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 2,
                            rows: 2
                        }
                        },
                    {
                        //mobile
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            rows: 2
                        }
                    },
                    {
                        //mobile
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 2,
                            rows: 2
                        }
                    }
                ]
                
            });

            $('.collection-products-slider').slick({
                slidesToShow: 4,
                rows: 0,
                infinite:false,
                arrows:true,
                draggable: true,
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        //tablet
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 2,
                        }
                        },
                    {
                        //mobile
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        //mobile
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
                
            });

        }catch (error) {
            console.log(error);
        }

    }

    function progressIni(){
        $('.collection-products-slider.'+cityName).on('beforeChange', function(event, slick, currentSlide, nextSlide) { 
            calc = ( (nextSlide) / (slick.slideCount - $('.collection-products-slider.'+cityName).slick("slickGetOption", "slidesToShow")) ) * 100;

            if(calc == 0){
                calc = ( (0.5) / (slick.slideCount - $('.collection-products-slider.'+cityName).slick("slickGetOption", "slidesToShow")) ) * 100;
                $('.'+cityName+'.progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
            }else{
                $('.'+cityName+'.progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
            }
            
        });

        $('.collection-products-slider-mobile.'+cityName).on('beforeChange', function(event, slick, currentSlide, nextSlide) { 
            calc = ( (nextSlide) / (slick.slideCount - $('.collection-products-slider.'+cityName).slick("slickGetOption", "slidesToShow")) ) * 100;

            if(calc == 0){
                calc = ( (0.5) / (slick.slideCount - $('.collection-products-slider-mobile.'+cityName).slick("slickGetOption", "slidesToShow")) ) * 100;
                $('.'+cityName+'.progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
            }else{
                $('.'+cityName+'.progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
            }
            
        });

    }

// END POPULAR PRODUCT SLIDER

$(window).resize(function() {
    var width = $(window).width(); 

    console.log("Window width: " + width);
    $('.collection-products-slider').slick('refresh');
    $('.collection-products-slider-mobile').slick('refresh');
    $('.category_list_slider').slick('refresh');
});